<div class="lead-content">
  <!-- Contenedor interno para el resto del contenido -->
  <div class="main-content-inner">
    <!-- Sección de probabilidad y datos relacionados -->
    <div class="probability-section">
      <!-- Prioridad (Estrellas) -->
      <div class="probability-item">
        <span class="probability-label">Prioridad</span>
        <div *ngIf="!isFieldEditing('priority')" class="priority-stars" (click)="onFieldClick('priority', $event)"
          style="cursor: pointer;">
          <app-st-icon *ngFor="let star of priorityStars" [name]="'star'" [filled]="star"
            [style.color]="star ? '#F59E0B' : '#EBEBEB'" style="font-size: 16px;"></app-st-icon>
        </div>
        <div *ngIf="isFieldEditing('priority')" class="priority-stars top-edit-spacer" aria-hidden="true">
          <app-st-icon *ngFor="let star of priorityStars" [name]="'star'" [filled]="star"
            [style.color]="star ? '#F59E0B' : '#EBEBEB'" style="font-size: 16px;"></app-st-icon>
        </div>
        <nz-select *ngIf="isFieldEditing('priority')" nzSize="large" [ngModel]="lead?.priority"
          (nzOpenChange)="onEditOverlayOpenChange('priority', $event)"
          (ngModelChange)="onSelectChange('priority', $event)" [attr.data-field]="'priority'"
          nzPlaceHolder="Seleccione prioridad" nzAllowClear style="width: 150px;">
          <nz-option nzValue="Low" nzLabel="Baja"></nz-option>
          <nz-option nzValue="Medium" nzLabel="Media"></nz-option>
          <nz-option nzValue="High" nzLabel="Alta"></nz-option>
          <nz-option nzValue="VeryHigh" nzLabel="Muy Alta"></nz-option>
        </nz-select>
      </div>

      <!-- Centro de Costo -->
      <div class="probability-item" [class.editing-top-field]="isFieldEditing('costCenterId')">
        <span class="probability-label">Centro de Costo</span>
        <span *ngIf="!isFieldEditing('costCenterId')" class="probability-value"
          (click)="onFieldClick('costCenterId', $event)" style="cursor: pointer;">{{ costCenterName }}</span>
        <span *ngIf="isFieldEditing('costCenterId')" class="probability-value top-edit-spacer" aria-hidden="true">
          {{ costCenterName }}
        </span>
        <nz-select *ngIf="isFieldEditing('costCenterId')" nzSize="large" [ngModel]="lead?.costCenterId"
          (nzOpenChange)="onEditOverlayOpenChange('costCenterId', $event)"
          (ngModelChange)="onSelectChange('costCenterId', $event)" [attr.data-field]="'costCenterId'"
          nzPlaceHolder="Seleccione centro de costo" nzShowSearch nzAllowClear style="width: 200px;">
          <nz-option *ngFor="let costCenter of costCenters" [nzValue]="costCenter.id" [nzLabel]="costCenter.name">
          </nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Sección de datos en dos columnas -->
    <div class="details-data-section">
      <!-- COLUMNA IZQUIERDA (Datos) -->
      <div class="details-column">
        <!-- Nombre -->
        <div class="detail-row">
          <span class="detail-label">Nombre:</span>
          <span *ngIf="!isFieldEditing('name')" class="detail-value" (click)="onFieldClick('name', $event)"
            style="cursor: pointer;">{{ leadName }}</span>
          <input *ngIf="isFieldEditing('name')" type="text" nzSize="large" nz-input [ngModel]="leadNameForInput"
            (blur)="onFieldBlur('name', $event)" [attr.data-field]="'name'" placeholder="Introduce nombre..."
            style="width: 200px;">
        </div>
        <!-- Empresa Intermediaria -->
        <div class="detail-row" [class.field-error]="hasFieldError('intermediaryCompanyId')">
          <span class="detail-label" [class.error-label]="hasFieldError('intermediaryCompanyId')">Empresa Intermediaria:</span>
          <span *ngIf="!isFieldEditing('intermediaryCompanyId')" class="detail-value"
            [class.error-value]="hasFieldError('intermediaryCompanyId')"
            (click)="onFieldClick('intermediaryCompanyId', $event)" style="cursor: pointer;">
            {{ intermediaryCompanyName }}
          </span>
          <nz-select *ngIf="isFieldEditing('intermediaryCompanyId')" nzSize="large"
            [ngModel]="lead?.intermediaryCompanyId"
            (nzOpenChange)="onEditOverlayOpenChange('intermediaryCompanyId', $event)"
            (ngModelChange)="onSelectChange('intermediaryCompanyId', $event)"
            [attr.data-field]="'intermediaryCompanyId'"
            [nzStatus]="hasFieldError('intermediaryCompanyId') ? 'error' : ''"
            nzPlaceHolder="Seleccione empresa intermediaria" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let company of companiesList" [nzValue]="company.id" [nzLabel]="company.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Empresa Cliente -->
        <div class="detail-row" [class.field-error]="hasFieldError('clientCompany')">
          <span class="detail-label" [class.error-label]="hasFieldError('clientCompany')">Empresa Cliente:</span>
          <span *ngIf="!isFieldEditing('clientCompany')" class="detail-value"
            [class.error-value]="hasFieldError('clientCompany')" (click)="onFieldClick('clientCompany', $event)"
            style="cursor: pointer;">
            <ng-container *ngIf="companiesListLoaded">{{ getLeadClientCompanyDisplay() }}</ng-container>
            <span *ngIf="!companiesListLoaded" style="opacity: 0; min-width: 1ch;">-</span>
          </span>
          <nz-select *ngIf="isFieldEditing('clientCompany')" nzSize="large"
            [ngModel]="getClientCompanyId(lead?.clientCompany)"
            (nzOpenChange)="onEditOverlayOpenChange('clientCompany', $event)"
            (ngModelChange)="onSelectChange('clientCompany', $event)" [attr.data-field]="'clientCompany'"
            [nzStatus]="hasFieldError('clientCompany') ? 'error' : ''" nzPlaceHolder="Seleccione empresa cliente"
            nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let company of companiesList" [nzValue]="company.id" [nzLabel]="company.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Contacto -->
        <div class="detail-row" [class.field-error]="hasFieldError('partnerId')">
          <span class="detail-label" [class.error-label]="hasFieldError('partnerId')">Contacto:</span>
          <div *ngIf="!isFieldEditing('partnerId')" class="detail-tag" [class.error-value]="hasFieldError('partnerId')"
            (click)="onFieldClick('partnerId', $event)" style="cursor: pointer;">
            <nz-avatar *ngIf="lead?.contactPartner"
              [nzSrc]="lead?.contactPartner?.avatar ? getSafeImageUrl(lead?.contactPartner?.avatar) : undefined"
              [nzText]="!lead?.contactPartner?.avatar ? getPartnerInitials(lead?.contactPartner) : undefined"
              [nzSize]="20" [style.backgroundColor]="!lead?.contactPartner?.avatar ? '#ffffff' : undefined"
              [style.color]="!lead?.contactPartner?.avatar ? '#000000' : undefined"
              [style.border]="!lead?.contactPartner?.avatar ? '1px solid #d9d9d9' : undefined"
              [style.fontWeight]="!lead?.contactPartner?.avatar ? '600' : undefined" style="margin-right: 8px;">
            </nz-avatar>
            <span>{{ contactName }}</span>
          </div>
          <app-avatar-select *ngIf="isFieldEditing('partnerId')" [ngModel]="lead?.partnerId"
            (ngModelChange)="onSelectChange('partnerId', $event)" [options]="contactList.length > 0 ? contactList : globalValuesService.partnerlist || []"
            [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent"
            [allowCreateNew]="true"
            [defaultParentId]="getClientCompanyId(lead?.clientCompany) || lead?.contactPartner?.parentId || null"
            [defaultIsEmployee]="true"
            [nzAllowClear]="false"
            [nzStatus]="hasFieldError('partnerId') ? 'error' : ''"
            [nzLoading]="contactLoading"
            [attr.data-field]="'partnerId'" placeholder="Seleccione contacto"
            (partnerCreated)="onPartnerCreated($event)"
            style="width: 200px;">
          </app-avatar-select>
        </div>
        <!-- Email -->
        <div class="detail-row">
          <span class="detail-label">Email:</span>
          <span *ngIf="!isFieldEditing('email')" class="detail-value" (click)="onFieldClick('email', $event)"
            style="cursor: pointer;">{{ lead?.email || lead?.contactPartner?.email || '-' }}</span>
          <input *ngIf="isFieldEditing('email')" type="email" nzSize="large" nz-input [ngModel]="lead?.email || ''"
            (blur)="onFieldBlur('email', $event)" [attr.data-field]="'email'" placeholder="Introduce email..."
            style="width: 200px;">
        </div>
        <!-- Teléfono -->
        <div class="detail-row">
          <span class="detail-label">Teléfono:</span>
          <span *ngIf="!isFieldEditing('phone')" class="detail-value" (click)="onFieldClick('phone', $event)"
            style="cursor: pointer;">{{ lead?.phone || lead?.contactPartner?.phone || '-' }}</span>
          <input *ngIf="isFieldEditing('phone')" type="tel" nzSize="large" nz-input [ngModel]="lead?.phone || ''"
            (blur)="onFieldBlur('phone', $event)" [attr.data-field]="'phone'" placeholder="Introduce teléfono..."
            style="width: 200px;">
        </div>
        <!-- Referido por -->
        <div class="detail-row">
          <span class="detail-label">Referido por:</span>
          <span *ngIf="!isFieldEditing('referencedById')" class="detail-value" (click)="onFieldClick('referencedById', $event)"
            style="cursor: pointer;">{{ referencedByName }}</span>
          <nz-select *ngIf="isFieldEditing('referencedById')" nzSize="large" [ngModel]="lead?.referencedById"
            (nzOpenChange)="onEditOverlayOpenChange('referencedById', $event)"
            (ngModelChange)="onSelectChange('referencedById', $event)" [attr.data-field]="'referencedById'"
            nzPlaceHolder="Seleccione partner" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let partner of globalValuesService.partnerlist" [nzValue]="partner.id" 
              [nzLabel]="(partner.name || '') + ' ' + (partner.surName || '')">
            </nz-option>
          </nz-select>
        </div>
        <!-- Fecha de Creación -->
        <div class="detail-row">
          <span class="detail-label">Fecha de Creación:</span>
          <span class="detail-value">{{ formatDate(lead?.createdOn ?? lead?.created_at ?? null) }}</span>
        </div>
        <!-- ID -->
<!--        <div class="detail-row">-->
<!--          <span class="detail-label">ID:</span>-->
<!--          <span class="detail-value">{{ (lead?.id || lead?.originalId || '-').toString() }}</span>-->
<!--        </div>-->
      </div>

      <!-- COLUMNA DERECHA (Admin) -->
      <div class="details-column">

        <!-- Equipo -->
        <div class="detail-row">
          <span class="detail-label">Equipo:</span>
          <span *ngIf="!isFieldEditing('teamId')" class="detail-value" (click)="onFieldClick('teamId', $event)"
            style="cursor: pointer;">{{ salesTeamName }}</span>
          <nz-select *ngIf="isFieldEditing('teamId')" nzSize="large" [ngModel]="getTeamIdForSelect()"
            (nzOpenChange)="onEditOverlayOpenChange('teamId', $event)"
            (ngModelChange)="onSelectChange('teamId', $event)" [attr.data-field]="'teamId'"
            nzPlaceHolder="Seleccione equipo de ventas" [nzAllowClear]="false" nzShowSearch style="width: 200px;">
            <nz-option *ngFor="let salesTeam of globalValuesService.salesTeams$.value || []" [nzValue]="salesTeam.id"
              [nzLabel]="salesTeam.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Comercial -->
        <div class="detail-row">
          <span class="detail-label">Comercial:</span>
          <div *ngIf="!isFieldEditing('userId')" class="detail-tag" (click)="onFieldClick('userId', $event)"
            style="cursor: pointer;">
            <nz-avatar *ngIf="lead?.comercialUser"
              [nzSrc]="lead?.comercialUser?.avatar ? getSafeImageUrl(lead?.comercialUser?.avatar) : undefined"
              [nzText]="!lead?.comercialUser?.avatar ? getUserInitialsFromUser(lead?.comercialUser) : undefined" [nzSize]="20"
              [style.backgroundColor]="!lead?.comercialUser?.avatar ? '#ffffff' : undefined"
              [style.color]="!lead?.comercialUser?.avatar ? '#000000' : undefined"
              [style.border]="!lead?.comercialUser?.avatar ? '1px solid #d9d9d9' : undefined"
              [style.fontWeight]="!lead?.comercialUser?.avatar ? '600' : undefined" style="margin-right: 8px;">
            </nz-avatar>
            <span>{{ commercialName }}</span>
          </div>
          <nz-select *ngIf="isFieldEditing('userId') && filteredUsersForTeam.length > 0" nzSize="large" [ngModel]="lead?.userId"
            (nzOpenChange)="onEditOverlayOpenChange('userId', $event)"
            (ngModelChange)="onSelectChange('userId', $event)" [attr.data-field]="'userId'" nzPlaceHolder="Seleccione comercial"
            nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let user of filteredUsersForTeam" [nzValue]="user.id"
              [nzLabel]="user.partner ? ((user.partner.name || '') + ' ' + (user.partner.surName || '')) : ''">
            </nz-option>
          </nz-select>
          <div *ngIf="isFieldEditing('userId') && filteredUsersForTeam.length === 0"
            style="width: 200px; padding: 8px; color: #999; font-size: 14px;">
            No hay comerciales disponibles para este equipo
          </div>
        </div>
        <!-- Compañía -->
        <div class="detail-row">
          <span class="detail-label">Compañía:</span>
          <span *ngIf="!isFieldEditing('companyId')" class="detail-value" (click)="onFieldClick('companyId', $event)"
            style="cursor: pointer;">{{ companyName }}</span>
          <nz-select *ngIf="isFieldEditing('companyId')" nzSize="large" [ngModel]="lead?.companyId"
            (nzOpenChange)="onEditOverlayOpenChange('companyId', $event)"
            (ngModelChange)="onSelectChange('companyId', $event)" [attr.data-field]="'companyId'"
            nzPlaceHolder="Seleccione compañía" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let company of companies" [nzValue]="company.id" [nzLabel]="company.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Sitio web -->
        <div class="detail-row">
          <span class="detail-label">Sitio web:</span>
          <span *ngIf="!isFieldEditing('website')" class="detail-value" (click)="onFieldClick('website', $event)"
            style="cursor: pointer;">{{ lead?.website || '-' }}</span>
          <input *ngIf="isFieldEditing('website')" type="text" nzSize="large" nz-input [ngModel]="lead?.website || ''"
            (blur)="onFieldBlur('website', $event)" [attr.data-field]="'website'" placeholder="Introduce sitio web..."
            style="width: 200px;">
        </div>
        <!-- Origin -->
        <div class="detail-row">
          <span class="detail-label">Origin:</span>
          <span *ngIf="!isFieldEditing('source')" class="detail-value" (click)="onFieldClick('source', $event)"
            style="cursor: pointer;">{{ lead?.source || '-' }}</span>
          <input *ngIf="isFieldEditing('source')" type="text" nzSize="large" nz-input [ngModel]="lead?.source || ''"
            (blur)="onFieldBlur('source', $event)" [attr.data-field]="'source'" placeholder="Introduce origin..."
            style="width: 200px;">
        </div>
        <!-- Puesto de trabajo -->
        <div class="detail-row">
          <span class="detail-label">Puesto de trabajo:</span>
          <span *ngIf="!isFieldEditing('jobTitle')" class="detail-value" (click)="onFieldClick('jobTitle', $event)"
            style="cursor: pointer;">{{ lead?.jobTitle || '-' }}</span>
          <input *ngIf="isFieldEditing('jobTitle')" type="text" nzSize="large" nz-input [ngModel]="lead?.jobTitle || ''"
            (blur)="onFieldBlur('jobTitle', $event)" [attr.data-field]="'jobTitle'"
            placeholder="Introduce puesto de trabajo..." style="width: 200px;">
        </div>
        <!-- Dirección (agrupada) -->
        <div style="display: flex; flex-direction: column;">
          <!-- Primera línea: Label y primer valor en la misma línea -->
          <div class="detail-row">
            <span class="detail-label">Dirección:</span>
            <span *ngIf="!isFieldEditing('street')" class="detail-value" (click)="onFieldClick('street', $event)"
              style="cursor: pointer;">{{ lead?.street || '-' }}</span>
            <input *ngIf="isFieldEditing('street')" type="text" nzSize="large" nz-input [ngModel]="lead?.street || ''"
              (blur)="onFieldBlur('street', $event)" [attr.data-field]="'street'" placeholder="Introduce dirección..."
              style="width: 200px;">
          </div>
          <!-- Líneas siguientes con labels -->
          <div *ngIf="!isAddressFieldEditing() && (lead?.street2 || (lead?.city && lead.city.trim() !== '' && lead.city.trim() !== '-') || (lead?.province && lead.province.trim() !== '') || (stateName && stateName !== '-') || (lead?.zip && lead.zip.trim() !== '') || (countryName && countryName !== '-'))"
            style="display: flex; flex-direction: column;">
            <!-- Dirección2 -->
            <div *ngIf="lead?.street2" class="detail-row">
              <span class="detail-label">Dirección 2:</span>
              <span class="detail-value" (click)="onFieldClick('street2', $event)"
                style="cursor: pointer;">{{ lead.street2 }}</span>
            </div>
            <!-- Ciudad -->
            <div *ngIf="lead?.city && lead.city.trim() !== '' && lead.city.trim() !== '-'" class="detail-row">
              <span class="detail-label">Ciudad:</span>
              <span class="detail-value" (click)="onFieldClick('city', $event)"
                style="cursor: pointer;">{{ lead.city }}</span>
            </div>
            <!-- Provincia -->
            <div *ngIf="(lead?.province && lead.province.trim() !== '') || (stateName && stateName !== '-')" class="detail-row">
              <span class="detail-label">Provincia:</span>
              <span class="detail-value" (click)="onFieldClick('province', $event)"
                style="cursor: pointer;">{{ (lead?.province && lead.province.trim() !== '') ? lead.province : (stateName && stateName !== '-' ? stateName : '') }}</span>
            </div>
            <!-- CP -->
            <div *ngIf="lead?.zip && lead.zip.trim() !== ''" class="detail-row">
              <span class="detail-label">CP:</span>
              <span class="detail-value" (click)="onFieldClick('zip', $event)"
                style="cursor: pointer;">{{ lead.zip }}</span>
            </div>
            <!-- País -->
            <div *ngIf="countryName && countryName !== '-'" class="detail-row">
              <span class="detail-label">País:</span>
              <span class="detail-value" (click)="onFieldClick('countryId', $event)"
                style="cursor: pointer;">{{ countryName }}</span>
            </div>
          </div>
          <!-- Campos de edición para los demás campos -->
          <div *ngIf="isAddressFieldEditing() && !isFieldEditing('street')"
            style="display: flex; flex-direction: column; gap: 8px;">
            <!-- Dirección2 -->
            <div *ngIf="isFieldEditing('street2')" class="detail-row">
              <span class="detail-label">Dirección 2:</span>
              <input type="text" nzSize="large" nz-input [ngModel]="lead?.street2 || ''"
                (blur)="onFieldBlur('street2', $event)" [attr.data-field]="'street2'"
                placeholder="Introduce dirección 2..." style="width: 200px;">
            </div>
            <!-- Ciudad -->
            <div *ngIf="isFieldEditing('city')" class="detail-row">
              <span class="detail-label">Ciudad:</span>
              <input type="text" nzSize="large" nz-input [ngModel]="lead?.city || ''"
                (blur)="onFieldBlur('city', $event)" [attr.data-field]="'city'" placeholder="Introduce ciudad..."
                style="width: 200px;">
            </div>
            <!-- Provincia -->
            <div *ngIf="isFieldEditing('province')" class="detail-row">
              <span class="detail-label">Provincia:</span>
              <input type="text" nzSize="large" nz-input
                [ngModel]="lead?.province || ''" (blur)="onFieldBlur('province', $event)" [attr.data-field]="'province'"
                placeholder="Introduce provincia..." style="width: 200px;">
            </div>
            <!-- CP -->
            <div *ngIf="isFieldEditing('zip')" class="detail-row">
              <span class="detail-label">CP:</span>
              <input type="text" nzSize="large" nz-input [ngModel]="lead?.zip || ''"
                (blur)="onFieldBlur('zip', $event)" [attr.data-field]="'zip'" placeholder="Código postal..."
                style="width: 200px;">
            </div>
            <!-- País -->
            <div *ngIf="isFieldEditing('countryId')" class="detail-row">
              <span class="detail-label">País:</span>
              <nz-select nzSize="large" [ngModel]="lead?.countryId"
                (nzOpenChange)="onEditOverlayOpenChange('countryId', $event)"
                (ngModelChange)="onSelectChange('countryId', $event)" [attr.data-field]="'countryId'"
                nzPlaceHolder="Seleccione país" nzShowSearch nzAllowClear style="width: 200px;">
                <nz-option *ngFor="let country of countries" [nzValue]="country.id" [nzLabel]="country.name">
                </nz-option>
              </nz-select>
            </div>
          </div>
        </div>
        <!-- Etiquetas -->
        <!-- <div class="detail-row">
          <span class="detail-label">Etiquetas:</span>
          <div *ngIf="!isFieldEditing('tags')"
               class="tags-container-wrapper"
               [class.clickable]="editPermissions"
               (click)="editPermissions && onFieldClick('tags', $event)"
               [style.cursor]="editPermissions ? 'pointer' : 'default'">
            <ng-container *ngIf="leadTags.length > 0; else noTagsTemplate">
              <div class="tags-container">
                <nz-tag
                  *ngFor="let tag of leadTags"
                  [nzColor]="tag.color || 'green'"
                  [nzMode]="editPermissions ? 'closeable' : 'default'"
                  (nzOnClose)="editPermissions && removeTag(tag.id, $event)">
                  {{ tag.name }}
                </nz-tag>
              </div>
            </ng-container>
            <ng-template #noTagsTemplate>
              <span class="detail-value" [style.color]="editPermissions ? '#666' : '#999'">
                {{ editPermissions ? 'Haz clic para agregar etiquetas' : '-' }}
              </span>
            </ng-template>
          </div>
          <nz-select
            *ngIf="isFieldEditing('tags')"
            nzSize="large"
            [ngModel]="tagIds"
            (ngModelChange)="onArrayChange('tags', $event)"
            (nzOpenChange)="onArraySelectClose('tags', $event)"
            [attr.data-field]="'tags'"
            nzPlaceHolder="Seleccione etiquetas"
            nzMode="multiple"
            nzAllowClear
            style="width: 200px;">
            <nz-option
              *ngFor="let tag of tags"
              [nzValue]="tag.id"
              [nzLabel]="tag.name">
            </nz-option>
          </nz-select>
        </div> -->
      </div>
    </div>

    <!-- Tabs -->
    <nz-tabset *ngIf="afterViewInit" [(nzSelectedIndex)]="activeTabIndex"
      style="overflow-y: auto; overflow-x: hidden; min-height: 500px;">
      <nz-tab [nzTitle]="descripcionTemplate">
        <ng-template #descripcionTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'menu_book'"></app-st-icon>
          Descripción
        </ng-template>
        <div class="tab-content">
          <div *ngIf="!isFieldEditing('description')" class="text-label-14 text-dark lead-description description-view"
            [class.description-edit-mode]="isFieldEditing('description')"
            style="hyphens: auto; padding: 12px 15px;" (click)="onFieldClick('description', $event)">
            <span *ngIf="!hasMeaningfulLeadDescription(lead?.description)">-</span>
            <span *ngIf="hasMeaningfulLeadDescription(lead?.description)" class="rich-text-content" [innerHTML]="lead?.description"></span>
          </div>
          <div *ngIf="isFieldEditing('description')">
            <quill-editor
              #leadQuillEditor
              [(ngModel)]="editingFieldValue"
              [modules]="quillModules"
              [styles]="{height: '200px', width: '100%'}"
              (onBlur)="!isAddingLink && saveEditingField('description')"
              (onSelectionChanged)="onEditorSelectionChanged($event)">
            </quill-editor>
          </div>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="documentosTemplate">
        <ng-template #documentosTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'description'"></app-st-icon>
          Documentos
        </ng-template>
        <div class="tab-content">
          <app-doc-section [entityType]="'Lead'" [entityId]="lead?.id || lead?.originalId"
            [documents]="documents || []">
          </app-doc-section>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</div>

<!-- Template para el modal de link (contenido + footer en uno para tener contexto del componente) -->
<ng-template #linkModalTemplate let-component="$implicit.component">
  <div class="link-modal-content">
    <label class="link-modal-label">URL del enlace:</label>
    <input 
      #linkInput
      type="text" 
      [ngModel]="component?.linkModalUrl"
      (ngModelChange)="component && (component.linkModalUrl = $event)"
      placeholder="https://ejemplo.com"
      nz-input
      class="link-modal-input"
      (keydown.enter)="component?.onLinkModalEnter()"
    />
  </div>
  <div class="link-modal-footer">
    <button nz-button nzType="text" nzDanger nzShape="round" nzSize="large" (click)="component?.removeLinkFromSelection()">
      Quitar enlace
    </button>
    <span class="link-modal-footer-spacer"></span>
    <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="component?.closeLinkModal()">Cancelar</button>
    <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="component?.onLinkModalConfirm()">Aceptar</button>
  </div>
</ng-template>
